import { render, staticRenderFns } from "./SoldPage.vue?vue&type=template&id=6f320b80&lang=pug&"
import script from "./SoldPage.vue?vue&type=script&lang=js&"
export * from "./SoldPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports